import * as PusherPushNotifications from '@pusher/push-notifications-web'

export const beamsClient = new PusherPushNotifications.Client({
  instanceId: process.env.REACT_APP_PUSH_INSTANCE_ID || '',
})
